import React from 'react';
import {
  Dialog,
  DialogActions,
  DialogContent,
  DialogContentText,
  DialogTitle,
  Typography,
} from '@material-ui/core';

import PropTypes from 'prop-types';

import BasicButton from '../buttons/basicButton';

export default function AlertDialog1Option({ handleClose, message, open, title, data }) {
  return (
    <div>
      <Dialog
        open={open}
        aria-labelledby='alert-dialog-title'
        aria-describedby='alert-dialog-description'
      >
        <DialogTitle id='alert-dialog-title'>{title}</DialogTitle>
        <DialogContent>
          <DialogContentText id='alert-dialog-description'>{message}</DialogContentText>
          {data && (
            <Typography variant='body1' component='div'>
              {data.map((element) => `${element}, `)}
            </Typography>
          )}
        </DialogContent>
        <DialogActions>
          <BasicButton handleClick={handleClose} type='accept' />
        </DialogActions>
      </Dialog>
    </div>
  );
}

// Indica i controla els props que se han de passar al component
AlertDialog1Option.propTypes = {
  data: PropTypes.array,
  handleClose: PropTypes.func.isRequired,
  message: PropTypes.string.isRequired,
  open: PropTypes.bool.isRequired,
  title: PropTypes.string.isRequired,
};
